<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="6">
        <el-form :inline="true">
          <el-form-item>
            <el-input v-model="queryUserDesc"  size="small" placeholder="请输入查询条件" class="sx-input"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary"  size="small" @click="search">查询</el-button>
          </el-form-item>
        </el-form>

        <el-table v-loading="loading" :data="tableData" border highlight-current-row @row-click="handleCurrentRowChange">
          <el-table-column label="用户列表">
            <el-table-column prop="id" label="编号" v-if="isShow">
            </el-table-column>
            <el-table-column prop="userName" sortable label="用户名" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="userDesc" sortable label="姓名" show-overflow-tooltip>
            </el-table-column>
          </el-table-column>
        </el-table>

        <el-pagination small @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next" :total="totalRows">
        </el-pagination>

      </el-col>
      <el-col :span="8">

        <el-table :data="NoTableData" border highlight-current-row @row-click="handleNoChange" v-loading="loading">
          <el-table-column label="未选列表">
            <el-table-column prop="id" label="编号" v-if="isShow">
            </el-table-column>
            <el-table-column prop="roleCode" label="角色编码" width="120" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="roleName" label="用户名称" show-overflow-tooltip>
            </el-table-column>
          </el-table-column>
        </el-table>
        <el-pagination small @current-change="NohandleCurrentChange" :current-page="NocurrentPage" :page-size="NopageSize"
          layout=" prev, pager, next" :total="NototalRows">
        </el-pagination>
        <div class="button-container1" style="padding-top: 10px;margin-left: 50px;">
          <i class="el-icon-arrow-down" @click="handleSave" style="font-size: 50px;margin-right: 160px;"></i>
          <i class="el-icon-arrow-up" @click="handleRemove" style="font-size: 50px;"></i>
        </div>

        <el-table v-loading="loading" :data="YesTableData" border highlight-current-row @row-click="handleYesChange">
          <el-table-column label="已选列表">
            <el-table-column prop="id" label="编号" width="60" v-if="isShow">
            </el-table-column>
            <el-table-column prop="roleCode" label="角色编码" width="120" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="roleName" label="用户名称" show-overflow-tooltip>
            </el-table-column>
          </el-table-column>
        </el-table>
        <el-pagination small @current-change="YeshandleCurrentChange" :current-page="YescurrentPage" :page-size="YespageSize"
          layout="  prev, pager, next" :total="YestotalRows">
        </el-pagination>
      </el-col>
      <el-col :span="10">
        <div class="tree-container">
          <el-tree v-loading="loadingTree" :data="dataTree" :props="defaultProps" ref='tree' node-key="id"
            show-checkbox>
          </el-tree>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
  import axios from '@/axios';
  export default {
    data() {
      return {
        dataTree: [],
        defaultProps: {
          children: 'children',
          label: 'text'
        },
        menuId: [],
        //表格初始化参数
        tableData: [],
        currentPage: 1,
        totalRows: 0,
        pageSize: 10,

        NoTableData: [],
        NocurrentPage: 1,
        NototalRows: 0,
        NopageSize: 10,

        YesTableData: [],
        YescurrentPage: 1,
        YestotalRows: 0,
        YespageSize: 10,

        selectUserId: '',
        userId: '',
        roleIdNo: '',
        roleIdYes: '',

        //查询条件
        queryUserDesc: '',
        isShow: false,
        loading: true,
        loadingTree: true,
      }
    },
    //界面渲染完毕调用   初始化表格参数
    mounted() {
      this.getTableData()
      this.getNoTableData()
      this.getYesTableData()
      this.getDataTree()
    },
    methods: {
      // 获取table数据
      getTableData() {
        //console.log("获取table数据getTableData")
        var url = 'framework/SysUser/query.do'
        var param = {
          page: this.currentPage,
          rows: this.pageSize,
          userDesc: this.queryUserDesc
        }
        axios.get(url, param).then(response => {
          this.tableData = response.data.data.list
          this.totalRows = response.data.data.total
          if (response) {
            this.loading = false
          } else {
            this.loading = true
          }
        });
      },
      // 修改当前页事件
      handleCurrentChange(val) {
        this.currentPage = val
        this.getTableData()
      },
      NohandleCurrentChange(val) {
        this.NocurrentPage = val
        this.getNoTableData()
      },
      YeshandleCurrentChange(val) {
        this.YescurrentPage = val
        this.getYesTableData()
      },
      search() {
        this.getTableData()
      },
      getDataTree() {
        //console.log("获取table数据getDataTree")
        var url = 'framework/SysParent/queryMenu.do?userId=1'
        var param = {}
        axios.get(url, param).then(response => {
          this.dataTree = response.data.data
          if (response) {
            this.loadingTree = false
          } else {
            this.loadingTree = true
          }
        });
      },
      getNoTableData() {
        //console.log("获取table数据getTableData")
        var url = 'framework/SysRole/querySystemRolePage.do'
        var param = {
          page: this.NocurrentPage,
          rows: this.NopageSize,
          userId: this.selectUserId
        }
        axios.get(url, param).then(response => {

          this.NoTableData = response.data.data.list
          this.NototalRows = response.data.data.total
        });
      },
      getYesTableData() {
        //console.log("获取table数据getTableData")
        var url = 'framework/SysRole/queryUserRolePage.do'
        var param = {
          page: this.YescurrentPage,
          rows: this.YespageSize,
          userId: this.selectUserId
        }
        axios.get(url, param).then(response => {
          this.YesTableData = response.data.data.list
          this.YestotalRows = response.data.data.total
        });
      },
      handleCurrentRowChange(val) {
        this.selectUserId = val.id
        this.userId = val.id
        var url = 'framework/SysRoleMenu/queryByRoleId.do'
        var param = {
          roleId: this.selectUserId
        }
        axios.get(url, param).then(response => {
          this.getNoTableData()
          this.getYesTableData()
        });
      },
      handleNoChange(val) {
        this.roleIdNo = val.id
        // console.log("roleIdNo:"+this.roleIdNo);
        var url = 'framework/SysRoleMenu/queryByRoleId.do'
        var param = {
          roleId: this.roleIdNo
        }
        axios.post(url, param).then(response => {
          this.$refs.tree.setCheckedKeys(response.data.data.split(","))
        });
      },
      handleYesChange(val) {
        this.roleIdYes = val.id
        // console.log("roleIdYes:"+this.roleIdYes);
        var url = 'framework/SysRoleMenu/queryByRoleId.do'
        var param = {
          roleId: this.roleIdYes
        }
        axios.post(url, param).then(response => {
          this.$refs.tree.setCheckedKeys(response.data.data.split(","))
        });
      },

      handleSave(row) {
        var url = 'framework/SysUserRole/save.do'

        var param = {
          userId: this.userId,
          roleId: this.roleIdNo,

        }
        axios.post(url, param).then(response => {
          if (response.data.code == '0') {
            this.$message({
              type: 'success',
              message: '操作成功!',
            });
            this.getTableData()
            this.getDataTree()
            this.getNoTableData()
            this.getYesTableData()
          } else {
            this.$message({
              type: 'error',
              message: '操作失败!' + response.data.msg
            });
          }

        });
      },
      handleRemove(row) {
        var url = 'framework/SysUserRole/remove.do'
        var addId = sessionStorage.getItem('userId');
        var param = {
          userId: this.userId,
          roleId: this.roleIdYes,
        }
        axios.post(url, param).then(response => {
          if (response.data.code == '0') {
            this.$message({
              type: 'success',
              message: '操作成功!',
            });
            this.getTableData()
            this.getDataTree()
            this.getNoTableData()
            this.getYesTableData()
          } else {
            this.$message({
              type: 'error',
              message: '操作失败!' + response.data.msg
            });
          }


        });
      }

    },
  }
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/view/system/userrole.vue